export enum Sections {
  BasicInfo = 'basic-info',
  Description = 'description',
  ApplicationForm = 'application-form',
  HiringPipeline = 'hiring-pipeline',
  HiringTeam = 'hiring-team',
  InternalEvaluationForms = 'internal-evaluation-forms',
  SmartActions = 'smart-actions',
}
